import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Divider, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
const Dialog = (props) => {
    const { t } = useTranslation('common');
    const { children, onClose, actions, titleProps, ...cmpProps } = props;
    const { Icon: TitleIcon, text: titleText, ...restTitleProps } = titleProps;
    return (_jsxs(MuiDialog, { onClose: (_, reason) => {
            if (reason === 'backdropClick') {
                return;
            }
            onClose(reason);
        }, ...cmpProps, children: [_jsxs(DialogTitle, { sx: { alignItems: 'center', display: 'flex', gap: 1, p: 0 }, ...restTitleProps, children: [TitleIcon ? _jsx(TitleIcon, {}) : null, _jsx(Typography, { sx: { flexGrow: 1, fontWeight: 700 }, children: titleText }), _jsx(IconButton, { "aria-label": t('body.dialog.actions.close'), onClick: () => {
                            onClose('closeButtonClick');
                        }, children: _jsx(CloseIcon, {}) })] }), _jsx(Divider, {}), _jsx(DialogContent, { sx: { px: 1 }, children: children }), actions ? (_jsx(DialogActions, { disableSpacing: true, sx: {
                    alignItems: 'stretch',
                    display: 'grid',
                    gap: 1,
                    gridAutoColumns: 'minmax(auto, 1fr)',
                    gridAutoFlow: 'column',
                }, children: actions })) : null] }));
};
export default Dialog;
